import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title, 
  description, 
  canonical, 
  ogImage, 
  ogType = 'website', 
  keywords,
  noindex = false 
}) => {
  const { pathname } = useLocation();
  const siteName = 'WiaSoft';
  const fullTitle = title ? `${siteName} - ${title}` : 'WiaSoft - Geleceğin Yazılım Çözümleri';
  const siteUrl = 'https://wiasoft.com';
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : `${siteUrl}${pathname}`;

  // Default description if not provided
  const defaultDescription = "WiaSoft, web yazılım, mobil uygulama, masaüstü yazılım ve robotik kodlama alanlarında yenilikçi ve profesyonel teknoloji çözümleri sunar.";

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={ogImage || `${siteUrl}/assets/img/logo/logo.png`} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullCanonical} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={ogImage || `${siteUrl}/assets/img/logo/logo.png`} />

      {/* Robots */}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "url": siteUrl,
          "name": siteName,
          "logo": `${siteUrl}/assets/img/logo/logo.png`,
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+90-850-308-0942",
            "contactType": "customer service",
            "areaServed": "TR",
            "availableLanguage": "Turkish"
          },
          "sameAs": [
            "https://www.facebook.com/wiasoft",
            "https://www.instagram.com/wiasoft",
            "https://www.linkedin.com/company/wiasoft"
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
